/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{t as e}from"vendor/connectRefinementList";var t=e(()=>null);export{t as VirtualRefinementList};